import { render, staticRenderFns } from "./WorkOrderSupplies.vue?vue&type=template&id=493dd246&"
import script from "./WorkOrderSupplies.vue?vue&type=script&lang=js&"
export * from "./WorkOrderSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports